import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = {
  colspan: "4",
  style: {"padding":"0","background":"#f4f4f4"},
  class: "py-2 px-0"
}
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = {
  colspan: "4",
  style: {"padding":"0","background":"#f4f4f4"},
  class: "py-2 px-0"
}
const _hoisted_14 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_AuditCheckCard = _resolveComponent("AuditCheckCard")!
  const _component_AuditCheckDocumentDialog = _resolveComponent("AuditCheckDocumentDialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_AccountableAccountBalanceDetailOpenPoints = _resolveComponent("AccountableAccountBalanceDetailOpenPoints")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_ReconciliationFullClient = _resolveComponent("ReconciliationFullClient")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (
                    _ctx.showSepa ||
                    _ctx.openPointMode ||
                    (_ctx.availableDiagnostics && _ctx.availableDiagnostics.length > 1)
                )
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "mb-1"
                }, {
                  default: _withCtx(() => [
                    (_ctx.showSepa && !_ctx.openPointMode)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_primary, {
                              block: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.payDialog = true)),
                              disabled: _ctx.disabledSepa
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.sepaTitle), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, { class: "d-flex justify-end" }, {
                      default: _withCtx(() => [
                        (_ctx.availableDiagnostics && _ctx.availableDiagnostics.length > 1)
                          ? (_openBlock(), _createBlock(_component_v_select, {
                              key: 0,
                              modelValue: _ctx.diagnosticSorting,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.diagnosticSorting) = $event)),
                              items: _ctx.availableDiagnostics,
                              class: "pr-2",
                              outlined: "",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue", "items"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_ctx.openPointMode)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "2",
                          class: "pr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_menu, { "offset-y": "" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_primary, _mergeProps({ loading: _ctx.exportLoading }, props, { block: "" }), {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("Exporter")
                                  ])),
                                  _: 2
                                }, 1040, ["loading"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                    { title: 'docx', icon: '$fa-file-word' },
                                    { title: 'xlsx', icon: '$fa-file-excel' },
                                    { title: 'pdf', icon: '$fa-file-pdf' },
                                ], (item, index) => {
                                      return _createVNode(_component_v_list_item, {
                                        key: index,
                                        class: "px-8",
                                        onClick: ($event: any) => (_ctx.exportToFormat(item.title))
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, { color: "secondary" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.icon), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    }), 64))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary",
                          class: "mr-3"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (!_ctx.loading && _ctx.openPoints != null)
                      ? (_openBlock(), _createBlock(_component_v_window, {
                          key: 0,
                          modelValue: _ctx.wizardStep,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.wizardStep) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: 1 }, {
                              default: _withCtx(() => [
                                (_ctx.openPointMode)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      class: "pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.openPoints.document)
                                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pa-3 fill-height bg-primary-foreground rounded-xl",
                                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showItems(_ctx.openPoints.document.notAnalysed)))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "2",
                                                      class: "d-flex align-center justify-center",
                                                      style: {"border-right":"1px #ededed solid"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                    _ctx.openPoints.document.notAnalysed.count
                                                        ? 'red'
                                                        : 'green'
                                                
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.openPoints.document.notAnalysed.count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "10",
                                                      class: "d-flex align-center pl-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("openPoints.notAnalysedDocuments", {
                                                    count: _ctx.openPoints.document.notAnalysed.count,
                                                })), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.auditCheckDocumentsWithAnomalyCount > 0)
                                          ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_AuditCheckCard, {
                                                  auditCheckItemsCount: _ctx.auditCheckDocumentsWithAnomalyCount,
                                                  onClick: _ctx.onAuditCheckCardClicked,
                                                  class: "cursor-pointer"
                                                }, null, 8, ["auditCheckItemsCount", "onClick"]),
                                                _createVNode(_component_AuditCheckDocumentDialog, {
                                                  modelValue: _ctx.shouldAuditCheckDocumentWithAnomalyDialogBeVisible,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shouldAuditCheckDocumentWithAnomalyDialogBeVisible) = $event)),
                                                  auditChecks: _ctx.auditCheckDocumentsWithAnomaly,
                                                  companyId: _ctx.companyId
                                                }, null, 8, ["modelValue", "auditChecks", "companyId"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                        _ctx.openPoints.document && _ctx.openPoints.document.pendingValidation
                                    )
                                          ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pa-3 fill-height bg-primary-foreground rounded-xl",
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showItems(_ctx.openPoints.document.pendingValidation)))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "2",
                                                      class: "d-flex align-center justify-center",
                                                      style: {"border-right":"1px #ededed solid"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                    _ctx.openPoints.document.pendingValidation.count
                                                        ? 'red'
                                                        : 'green'
                                                
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.openPoints.document.pendingValidation.count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "10",
                                                      class: "d-flex align-center pl-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("openPoints.toValidateDocuments", {
                                                    count: _ctx.openPoints.document.pendingValidation
                                                        .count,
                                                })), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                        _ctx.openPoints.reconciliation &&
                                        _ctx.openPoints.reconciliation.pendingValidation
                                    )
                                          ? (_openBlock(), _createBlock(_component_v_col, { key: 3 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pa-3 fill-height bg-primary-foreground rounded-xl",
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (
                                            _ctx.showItems(_ctx.openPoints.reconciliation.pendingValidation)
                                        ))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "2",
                                                      class: "d-flex align-center justify-center",
                                                      style: {"border-right":"1px #ededed solid"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                    _ctx.openPoints.reconciliation.pendingValidation
                                                        .count
                                                        ? 'red'
                                                        : 'green'
                                                
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.openPoints.reconciliation.pendingValidation
                                                        .count
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "10",
                                                      class: "d-flex align-center pl-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("openPoints.toValidateReconciliations", {
                                                    count: _ctx.openPoints.reconciliation
                                                        .pendingValidation.count,
                                                })), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                        _ctx.openPoints.reconciliation &&
                                        _ctx.openPoints.reconciliation.pendingValidation
                                    )
                                          ? (_openBlock(), _createBlock(_component_v_col, { key: 4 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pa-3 fill-height bg-primary-foreground rounded-xl",
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showWaitingBT()))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "2",
                                                      class: "d-flex align-center justify-center",
                                                      style: {"border-right":"1px #ededed solid"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: 
                                                    _ctx.openPoints.waitingAccount.accountingTransactions
                                                        .length
                                                        ? 'red'
                                                        : 'green'
                                                
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.openPoints.waitingAccount.accountingTransactions
                                                        .length
                                                        ? "$fa-exclamation-triangle"
                                                        : "$fa-check"), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["color"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "10",
                                                      class: "d-flex align-center pl-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("openPoints.waitingAccount", {
                                                    count: _ctx.openPoints.waitingAccount
                                                        .accountingTransactions.length,
                                                })), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.outStangingType || _ctx.outStangingType === 'user')
                                  ? (_openBlock(), _createBlock(_component_v_row, { key: _ctx.refreshKey }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tabs, {
                                              modelValue: _ctx.tabStep,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tabStep) = $event)),
                                              "fixed-tabs": "",
                                              style: {"background-color":"transparent !important","border-radius":"16px 16px 0 0","overflow":"hidden"},
                                              id: "EnCours"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                _ctx.openPoints.waitingAccount &&
                                                _ctx.openPoints.waitingAccount.accountingTransactions &&
                                                _ctx.openPoints.waitingAccount.accountingTransactions
                                                    .length
                                            )
                                                  ? (_openBlock(), _createBlock(_component_v_tab, {
                                                      key: "471",
                                                      href: "#471"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("openPoints.category.471")), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openPoints.categories, (category) => {
                                                  return (_openBlock(), _createBlock(_component_v_tab, {
                                                    key: category.name,
                                                    href: '#' + category.name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("openPoints.category." + category.name3)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["href"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"]),
                                            _createVNode(_component_v_window, {
                                              modelValue: _ctx.tabStep,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tabStep) = $event))
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                _ctx.openPoints.waitingAccount &&
                                                _ctx.openPoints.waitingAccount.accountingTransactions &&
                                                _ctx.openPoints.waitingAccount.accountingTransactions
                                                    .length
                                            )
                                                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                                                      key: 0,
                                                      value: "471"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { class: "pt-1" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, null, {
                                                              default: _withCtx(() => [
                                                                (
                                                            _ctx.openPoints &&
                                                            _ctx.openPoints.waitingAccount &&
                                                            _ctx.openPoints.waitingAccount
                                                                .accountingTransactions
                                                        )
                                                                  ? (_openBlock(), _createBlock(_component_AccountableAccountBalanceDetailOpenPoints, {
                                                                      key: 0,
                                                                      companyId: _ctx.companyId,
                                                                      accountingPeriodId: _ctx.accountingPeriodId,
                                                                      mode: _ctx.mode,
                                                                      btOnly: true,
                                                                      accountableAccountInfo: 
                                                                _ctx.openPoints.waitingAccount
                                                            ,
                                                                      inAccountingTransactions: 
                                                                _ctx.openPoints.waitingAccount
                                                                    .accountingTransactions
                                                            ,
                                                                      onBankTransactionSelected: _cache[8] || (_cache[8] = ($event: any) => (
                                                                _ctx.onBankTransactionSelected($event)
                                                            )),
                                                                      onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.refresh()))
                                                                    }, null, 8, ["companyId", "accountingPeriodId", "mode", "accountableAccountInfo", "inAccountingTransactions"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openPoints.categories, (category) => {
                                                  return (_openBlock(), _createBlock(_component_v_window_item, {
                                                    value: category.name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_row, { class: "pt-1" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_data_table, {
                                                                "hide-default-header": true,
                                                                items: category.auxiliaryBalances,
                                                                "items-per-page": -1,
                                                                "hide-default-footer": "",
                                                                density: "compact",
                                                                class: "table"
                                                              }, {
                                                                item: _withCtx((props) => [
                                                                  (
                                                                    _ctx.showItem(
                                                                        category.name,
                                                                        props.item,
                                                                    )
                                                                )
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        (_openBlock(), _createElementBlock("tr", {
                                                                          style: {"background-color":"#fff"},
                                                                          key: props.item.key,
                                                                          onClick: _withModifiers(($event: any) => (
                                                                        _ctx.auxiliaryBalancesExpand(
                                                                            props.item,
                                                                        )
                                                                    ), ["stop"])
                                                                        }, [
                                                                          _createElementVNode("td", _hoisted_2, [
                                                                            _createVNode(_component_v_icon, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(props.item.showDetail
                                                                                ? "$fa-chevron-up"
                                                                                : "$fa-chevron-down"), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _createElementVNode("td", _hoisted_3, [
                                                                            _createElementVNode("div", null, [
                                                                              _createElementVNode("strong", null, _toDisplayString(_ctx.getAuxiliaryBalanceTitle(
                                                                                    props.item,
                                                                                )), 1)
                                                                            ])
                                                                          ]),
                                                                          _createElementVNode("td", _hoisted_4, [
                                                                            _createElementVNode("strong", null, _toDisplayString(props.item.diagnostic), 1)
                                                                          ]),
                                                                          _createElementVNode("td", _hoisted_5, [
                                                                            _createElementVNode("div", null, [
                                                                              _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                    props.item
                                                                                        .amountSigned,
                                                                                    undefined,
                                                                                )), 1)
                                                                            ])
                                                                          ])
                                                                        ], 8, _hoisted_1)),
                                                                        _withDirectives(_createElementVNode("tr", null, [
                                                                          _createElementVNode("td", _hoisted_6, [
                                                                            (
                                                                                props.item
                                                                                    .activateDetail
                                                                            )
                                                                              ? _withDirectives((_openBlock(), _createBlock(_component_AccountableAccountBalanceDetailOpenPoints, {
                                                                                  key: 0,
                                                                                  companyId: _ctx.companyId,
                                                                                  accountingPeriodId: 
                                                                                _ctx.accountingPeriodId
                                                                            ,
                                                                                  mode: _ctx.mode,
                                                                                  accountableAccountInfo: 
                                                                                props.item
                                                                            ,
                                                                                  inAccountingTransactions: 
                                                                                props.item
                                                                                    .accountingTransactions
                                                                            ,
                                                                                  notReconciliated: true,
                                                                                  onBankTransactionSelected: _cache[10] || (_cache[10] = ($event: any) => (
                                                                                _ctx.onBankTransactionSelected(
                                                                                    $event,
                                                                                )
                                                                            )),
                                                                                  onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.refresh()))
                                                                                }, null, 8, ["companyId", "accountingPeriodId", "mode", "accountableAccountInfo", "inAccountingTransactions"])), [
                                                                                  [_vShow, 
                                                                                props.item
                                                                                    .showDetail
                                                                            ]
                                                                                ])
                                                                              : _createCommentVNode("", true)
                                                                          ])
                                                                        ], 512), [
                                                                          [_vShow, props.item.showDetail]
                                                                        ])
                                                                      ], 64))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                "body.append": _withCtx(() => [
                                                                  _cache[17] || (_cache[17] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                                                                  _cache[18] || (_cache[18] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                                                  _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-right" }, [
                                                                    _createElementVNode("strong", null, "Total")
                                                                  ], -1)),
                                                                  _createElementVNode("td", _hoisted_7, [
                                                                    _createElementVNode("div", null, [
                                                                      _createElementVNode("strong", {
                                                                        style: _normalizeStyle(
                                                                            _ctx.totalAmmountSigned(
                                                                                category.auxiliaryBalances,
                                                                            ) < 0
                                                                                ? 'color:red'
                                                                                : ''
                                                                        )
                                                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                _ctx.totalAmmountSigned(
                                                                                    category.auxiliaryBalances,
                                                                                ),
                                                                                undefined,
                                                                            )), 5)
                                                                    ])
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["items"])
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 256))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_row, {
                                      key: 2,
                                      class: "pt-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            (_ctx.categoryTPC)
                                              ? (_openBlock(), _createBlock(_component_v_data_table, {
                                                  key: 0,
                                                  "hide-default-header": true,
                                                  items: _ctx.categoryTPC.auxiliaryBalances,
                                                  "items-per-page": -1,
                                                  "hide-default-footer": "",
                                                  density: "compact",
                                                  class: "table"
                                                }, {
                                                  item: _withCtx((props) => [
                                                    (_ctx.showItem('411', props.item))
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          (_openBlock(), _createElementBlock("tr", {
                                                            key: props.item.key,
                                                            onClick: _withModifiers(($event: any) => (
                                                        _ctx.auxiliaryBalancesExpand(props.item)
                                                    ), ["stop"])
                                                          }, [
                                                            _createElementVNode("td", _hoisted_9, [
                                                              _createVNode(_component_v_icon, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(props.item.showDetail
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_10, [
                                                              _createElementVNode("div", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.getAuxiliaryBalanceTitle(
                                                                        props.item,
                                                                    )), 1)
                                                              ])
                                                            ]),
                                                            _createElementVNode("td", _hoisted_11, [
                                                              _createElementVNode("strong", null, _toDisplayString(props.item.diagnostic), 1)
                                                            ]),
                                                            _createElementVNode("td", _hoisted_12, [
                                                              _createElementVNode("div", null, [
                                                                _createElementVNode("strong", {
                                                                  style: _normalizeStyle(
                                                                    props.item.amountSigned < 0
                                                                        ? 'color:red'
                                                                        : ''
                                                                )
                                                                }, _toDisplayString(props.item.amountSigned
                                                                        ? _ctx.newCommonFormatCurrency(
                                                                              props.item
                                                                                  .amountSigned,
                                                                              undefined,
                                                                          )
                                                                        : "-"), 5)
                                                              ])
                                                            ])
                                                          ], 8, _hoisted_8)),
                                                          _withDirectives(_createElementVNode("tr", null, [
                                                            _createElementVNode("td", _hoisted_13, [
                                                              (props.item.activateDetail)
                                                                ? _withDirectives((_openBlock(), _createBlock(_component_AccountableAccountBalanceDetailOpenPoints, {
                                                                    key: 0,
                                                                    companyId: _ctx.companyId,
                                                                    accountingPeriodId: _ctx.accountingPeriodId,
                                                                    mode: _ctx.mode,
                                                                    accountableAccountInfo: props.item,
                                                                    inAccountingTransactions: 
                                                                props.item.accountingTransactions
                                                            ,
                                                                    notReconciliated: true,
                                                                    onBankTransactionSelected: _cache[13] || (_cache[13] = ($event: any) => (
                                                                _ctx.onBankTransactionSelected($event)
                                                            ))
                                                                  }, null, 8, ["companyId", "accountingPeriodId", "mode", "accountableAccountInfo", "inAccountingTransactions"])), [
                                                                    [_vShow, props.item.showDetail]
                                                                  ])
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ], 512), [
                                                            [_vShow, props.item.showDetail]
                                                          ])
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  "body.append": _withCtx(() => [
                                                    _cache[20] || (_cache[20] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                                                    _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                                    _cache[22] || (_cache[22] = _createElementVNode("td", { class: "text-right" }, [
                                                      _createElementVNode("strong", null, "Total")
                                                    ], -1)),
                                                    _createElementVNode("td", _hoisted_14, [
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.totalAmmountSigned(
                                                                _ctx.categoryTPC.auxiliaryBalances,
                                                            ),
                                                            undefined,
                                                        )), 1)
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 1
                                                }, 8, ["items"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 2 }, {
                              default: _withCtx(() => [
                                (_ctx.bankTransactionId)
                                  ? (_openBlock(), _createBlock(_component_ReconciliationFullClient, {
                                      openPoints: true,
                                      companyId: _ctx.companyId,
                                      bankTransactionId: _ctx.bankTransactionId,
                                      key: _ctx.bankTransactionId,
                                      onBack: _cache[14] || (_cache[14] = ($event: any) => (_ctx.wizardStep = 1))
                                    }, null, 8, ["companyId", "bankTransactionId"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}